import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { Auth0Config } from '../data-access/types/auth0-types';
import { AUTH0_LIB_CONFIG } from '../data-access/types/auth0-config.token';

export interface ProvideAuthOptions {
    config: Auth0Config;
    storageKey: string;
    /** Keys to remove from localStorage on logout. When omitted, all localStorage is cleared. */
    logoutStorageClear?: string[];
}

export function provideAuth({ config, storageKey, logoutStorageClear }: ProvideAuthOptions): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: AUTH0_LIB_CONFIG,
            useValue: { auth0Config: config, storageKey, logoutStorageClear },
        },
    ]);
}
